import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateAdapter, MatDialog, MatSnackBar } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { Auth } from '../../../../../autentication/Auth';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { PixTransferRequest } from '../../../models/transfer-request.model';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { PixKey } from '../../../models/key.model';
import * as moment from 'moment';
import { PixReceipt } from '../../../models/receipt.model';
import { PixKeysService } from '../../../keys/keys.service';
import { PixPaymentFavored, PixPaymentFavoredAccount } from '../../../models/payment-favored.model';
import { PixTransferReturn, PixTransferReturnSituacaoTransferencia, PixTransferReturnSucesso } from '../../../models/transfer-return.model';
import { PixQrCodeDynamicService } from '../qr-code-dynamic.service';
import { PixPaymentKeyFavoredCreateDetailComponent } from '../../../payment-key/favored-create/details/details.component';
import { PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { PixPaymentKeyService } from '../../../payment-key/payment-key.service';
import { TipoIniciacao } from '../../../models/tipo-iniciacao.enum';
import { TipoIniciacaoTransferencia } from '../../../models/tipo-iniciacao-transacao.enum';
import { ModalAntifraudWarningComponent } from '../../../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';

@Component({
	selector: 'app-pix-payment-key-favored-create-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixQrCodeDynamicAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public selectedPixQrCodeDynamic: PixQrCodeReturn;
	public guid = '';
	private scheduledPayment = false;
	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	showAntifraudScreen: boolean;

	constructor(
		private autenticationService: AutenticationService,
		private qrCodeDynamicService: PixQrCodeDynamicService,
		private pixPaymentKeyService: PixPaymentKeyService,
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
	) {}

	ngOnInit() {
		this.selectedPixQrCodeDynamic = this.qrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.guid = Util.generateGUID();

		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.selectedPixQrCodeDynamic === undefined ||
			this.selectedPixQrCodeDynamic.chavePix === undefined ||
			this.selectedPixQrCodeDynamic.qrCodeDinamico === undefined;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		const model = this.generatePixTransferModel();

		this.pixPaymentKeyService.postTransfer(model).subscribe(data => {
			if (data.Sucesso) {
				const result = Util.keysToCamel(data.Retorno) as PixTransferReturn;
				this.processResult(result);
			}
		}, error => {
			this.handleError(error);
		});
	}

	processResult(result: PixTransferReturn) {
		switch (result.situacaoTransferencia) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				this.generateReceiptScheduled(false);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.selectedPixQrCodeDynamic.qrCodeDinamico.devedor.nome,
					valor: this.selectedPixQrCodeDynamic.valor,
					dataContabil: new Date(),
					complemento: this.selectedPixQrCodeDynamic.qrCodeDinamico.mensagem,
					codigoTransacao: result.sucesso !== undefined ? result.sucesso.codigoTransacao : null,
					agendado: this.scheduledPayment
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				this.generateReceiptScheduled(true);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.selectedPixQrCodeDynamic.qrCodeDinamico.devedor.nome,
					valor: this.selectedPixQrCodeDynamic.valor,
					dataContabil: new Date(),
					complemento: this.selectedPixQrCodeDynamic.qrCodeDinamico.mensagem,
					codigoTransacao: result.sucesso !== undefined ? result.sucesso.codigoTransacao : null,
					agendado: this.scheduledPayment
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REALIZADA:
				this.generateReceipt(result.sucesso);
				break;
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
				this.openModal(
					'Estamos processando essa transação',
					'Essa transação esta demorando um pouco mais que o normal',
					'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item em Transações não realizadas no menu Transações',
					'Entendi');
				break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REPROVADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_EXPIRADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.ERRO_TRANSFERENCIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.REJEITADA_IF_DESTINO:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_TESOURARIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_CLIENTE:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.AGUARDANDO_ANALISE_ANTIFRAUDE:
					this.setDataAntifraudScreen();
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_SUSPEITA_FRAUDE:
					this.router.navigate([""], { skipLocationChange: true });
					this.dialog.open(ModalAntifraudWarningComponent, {
						data: []
					});
					break;
			default:
				break;
		}
	}

	generateReceipt(ret: PixTransferReturnSucesso) {
		this.router.navigate(['pix/comprovante/' + ret.codigoTransacao + '/pix']);
	}

	generateReceiptScheduled(authorized: boolean) {
		const model = new PixReceipt();
		model.agendado = authorized;
		model.authorized = authorized;
		model.nome = this.selectedPixQrCodeDynamic.qrCodeDinamico.devedor.nome;
		model.dataTransacao = new Date();
		model.dataContabil = new Date();
		model.valor = this.selectedPixQrCodeDynamic.valor;
		model.complemento = this.selectedPixQrCodeDynamic.qrCodeDinamico.mensagem;
		model.codigoChave = this.selectedPixQrCodeDynamic.chavePix.codigo;
		model.tipoChave = this.selectedPixQrCodeDynamic.chavePix.tipoChave;
		model.iSPBNome = this.selectedPixQrCodeDynamic.conta.iSPBNome;
		model.agencia = this.selectedPixQrCodeDynamic.conta.numeroAgencia;
		model.numeroConta = this.selectedPixQrCodeDynamic.conta.numeroConta;
		model.tipoConta = this.selectedPixQrCodeDynamic.conta.tipoConta;
		model.documento = Util.removeNonNumerics(this.selectedPixQrCodeDynamic.qrCodeDinamico.recebedor.documento);

		this.pixPaymentKeyService.setSelectedPixReceipt(model);
	}

	generatePixTransferModel(): PixTransferRequest {
		const model = new PixTransferRequest();
		model.descricao = this.selectedPixQrCodeDynamic.qrCodeDinamico.mensagem;
		model.agencia = this.selectedPixQrCodeDynamic.conta.numeroAgencia;
		model.numeroConta = this.selectedPixQrCodeDynamic.conta.numeroConta ? this.selectedPixQrCodeDynamic.conta.numeroConta : null;
		model.tipoConta = this.selectedPixQrCodeDynamic.conta.tipoConta;
		model.documento = Util.removeNonNumerics(this.selectedPixQrCodeDynamic.conta.documento);
		model.iSPBCodigo = this.selectedPixQrCodeDynamic.conta.iSPBCodigo ? this.selectedPixQrCodeDynamic.conta.iSPBCodigo : null;
		model.nome = this.selectedPixQrCodeDynamic.conta.nome;
		model.codigoRequisicao = this.guid;
		model.codigoChave = new PixKey();
		model.codigoChave.codigo = this.selectedPixQrCodeDynamic.chavePix.codigo;
		model.codigoChave.tipoChave = this.selectedPixQrCodeDynamic.chavePix.tipoChave;
		model.codigoFimAFim = this.selectedPixQrCodeDynamic.codigoFimAFim;
		model.tipoCanalIniciacao = 'APLICATIVO';
		model.tipoIniciacao = TipoIniciacao.QRCODE_DINAMICO;
		model.tipoIniciacaoTransferencia = TipoIniciacaoTransferencia.QRCODE;
		model.numeroOrigem = null;
		model.codigoTransacaoQrCode = this.getCodigoTransacaoQrCode();
		model.dataAgendamento = null;
		model.descricao = this.selectedPixQrCodeDynamic.qrCodeDinamico.mensagem;
		model.valor = this.selectedPixQrCodeDynamic.valor;
		model.desconto = this.selectedPixQrCodeDynamic.desconto;
		model.multa = this.selectedPixQrCodeDynamic.multa;
		model.juros = this.selectedPixQrCodeDynamic.juros;
		model.original = this.selectedPixQrCodeDynamic.original;
		model.abatimento = this.selectedPixQrCodeDynamic.abatimento;

		return model;
	}

	getCodigoTransacaoQrCode() {
		return this.selectedPixQrCodeDynamic.codigoTransacao === '***' ? null : this.selectedPixQrCodeDynamic.codigoTransacao;
	}

	openModal(title: string, topText: string, text: string, btnName = 'Fechar', btnBackName = '') {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: title,
				topText: topText,
				text: text,
				btnName: btnName,
				btnBackName: btnBackName
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix']);
		});
	}

  setDataAntifraudScreen(): void {
    this.nameTransfer = Util.camelCaseText(this.selectedPixQrCodeDynamic.conta.nome);
		this.valueTransfer = this.selectedPixQrCodeDynamic.valor;
		this.dateTransfer = moment(this.selectedPixQrCodeDynamic.qrCodeDinamico.calendario.dataApresentacao).format('DD/MM/YYYY')
		this.showAntifraudScreen = true;
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	goBack = () => this.router.navigate(['pix/pagamento']);
	onSetSignatureForm = (form: FormGroup) => this.form = form;
}






// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/assignature/assignature.component.ts